import { useQueryClient } from '@tanstack/react-query';

import { FcmNotificationType } from '@/modules/notifications';
import { logger } from '@/utils/logger/logger';

import { useNotifications } from './use-notifications';

const TAG = 'useNotificationTrayRefresh:';

/**
 * Refreshes the notification tray data on every incoming FCM message.
 *
 * Invalidates both the notifications list and unread count queries so the
 * badge updates immediately without waiting for the user to open the tray.
 *
 * Must be mounted once in `AuthenticatedTemplate`.
 */
export const useNotificationTrayRefresh = (): void => {
  const queryClient = useQueryClient();

  useNotifications(FcmNotificationType.ALL, () => {
    logger.debug(TAG, 'Refreshing notification tray data');

    queryClient.invalidateQueries({ queryKey: ['notifications'], exact: true });
    queryClient.invalidateQueries({ queryKey: ['notifications', 'unread-count'], exact: true });
  });
};
